import React from "react";
import classNames from "classnames";

import { ReactComponent as InstagramIcon } from "./icons/instagram.svg";
import { ReactComponent as FacebookIcon } from "./icons/facebook.svg";
import { ReactComponent as TwitterIcon } from "./icons/twitter.svg";
import { ReactComponent as WebsiteIcon } from "./icons/website.svg";
import { ReactComponent as ChevronDownIcon } from "./icons/chevron-down.svg";
import { ReactComponent as MailIcon } from "./icons/mail.svg";

import styles from "./Icon.module.scss";

export const IconMap = {
  instagram: InstagramIcon,
  facebook: FacebookIcon,
  twitter: TwitterIcon,
  website: WebsiteIcon,
  "chevron-down": ChevronDownIcon,
  mail: MailIcon,
};

export type IconName = keyof typeof IconMap;

interface IconProps {
  className?: string;
  name: IconName;
  size?: "small" | "normal" | "large" | "xlarge";
  fill?: boolean;
}

const Icon: React.FC<IconProps> = ({ className, name, size, fill }) => {
  const cls = classNames(
    styles.icon,
    className,
    {
      [styles[size || ""]]: !!size,
    },
    {
      [styles.fill]: fill,
    }
  );

  const IconEl = IconMap[name];

  return (
    <span className={cls}>
      <IconEl />
    </span>
  );
};

export { Icon };
